import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {getSubBrandAdvertisementsList} from './getSubBrandAdvertisementsList';
import {ISubBrandAdvertisementsResponsePayload} from './types';

const useGetSubBrandAdvertisementsList = (
  payload: ISubBrandAdvertisementsResponsePayload,
) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-subBrand-advertisement-list', payload],
    async ({pageParam = 1}) =>
      getSubBrandAdvertisementsList({pageParam, payload}),
    {
      enabled: Boolean(payload?.subBrandGuid) ?? true,
      // v3 uses this (NOT `initialPageParam`)
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetSubBrandAdvertisementsList;
